import React from "react";
import { Link } from "react-router-dom";
import { Inbox, MessageSquare, CreditCard, Sparkles, LayoutDashboard, Tag, Zap } from "lucide-react";

const links = [
    { to: "/admin", label: "Dashboard", icon: LayoutDashboard, key: "dashboard" },
    { to: "/admin/orders", label: "Orders", icon: CreditCard, key: "orders" },
    { to: "/admin/quotes", label: "Quotes", icon: Inbox, key: "quotes" },
    { to: "/admin/contacts", label: "Contacts", icon: MessageSquare, key: "contacts" },
    { to: "/admin/requests", label: "Requests", icon: Zap, key: "requests" },
    { to: "/admin/photo-studio", label: "Photo Studio", icon: Sparkles, key: "photo-studio" },
    { to: "/admin/pricing", label: "Pricing", icon: Tag, key: "pricing" },
];

const AdminNav = ({ active }) => (
    <nav className="border-b border-white/10 bg-storm-navy/60 sticky top-0 z-10 backdrop-blur">
        <div className="container-x">
            <div className="flex items-center gap-0 overflow-x-auto scrollbar-none">
                {links.map(({ to, label, icon: Icon, key }) => {
                    const isActive = active === key;
                    return (
                        <Link
                            key={key}
                            to={to}
                            className={[
                                "flex items-center gap-2 px-4 py-3.5 text-xs font-heading uppercase tracking-wider whitespace-nowrap border-b-2 transition-colors",
                                isActive
                                    ? "border-storm-bolt text-storm-bolt"
                                    : "border-transparent text-white/50 hover:text-white/80 hover:border-white/20",
                            ].join(" ")}
                        >
                            <Icon className="w-3.5 h-3.5" />
                            {label}
                        </Link>
                    );
                })}
            </div>
        </div>
    </nav>
);

export default AdminNav;
